import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { AI_MODELS_CONFIG } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMConsts";
import type { ExplicitLLModel } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

interface IModelIcon {
    model: ExplicitLLModel;
}

export const ModelIcon = ({ model }: IModelIcon) => {
    const { Icon } = AI_MODELS_CONFIG[model];

    return (
        <Flex
            position="relative"
            alignItems="center"
            justifyContent="center"
            width="24px"
            height="24px"
            borderRadius="8px"
            background={colorsPalettes.carbon[0]}
            border={`1px solid ${colorsPalettes.carbon[100]}`}
        >
            <Icon size="xs" />
        </Flex>
    );
};
